import { Button } from '@components/ui/button';
import * as Sentry from '@sentry/react';
import { MessageCircle } from 'lucide-react';
import React, { useEffect, useRef } from 'react';

import { SimpleTooltip } from '@/components/ui/tooltip';
import { useStore } from '@/store';

export function SentryFeedbackButton() {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const user = useStore(state => state.user);

  useEffect(() => {
    const feedback = Sentry.getFeedback();
    Sentry.setUser({ email: user?.email, id: user?.id });

    if (!feedback || !buttonRef.current) {
      if (!feedback) {
        console.warn('Sentry feedback integration is not available');
      }
      return;
    }

    const unsubscribe = feedback.attachTo(buttonRef.current, {
      formTitle: 'Report an Issue',
      submitButtonLabel: 'Report an Issue',
      messagePlaceholder: 'What would you like to tell us?',
      showEmail: !user?.email,
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [user]);

  return (
    <SimpleTooltip content="Send feedback or report an issue" side="bottom">
      <Button
        ref={buttonRef}
        size="sm"
        variant="outline"
        aria-label="Send feedback"
        title="Send feedback or report an issue"
      >
        <MessageCircle className="h-4 w-4" />
      </Button>
    </SimpleTooltip>
  );
}
